import { useClipboard, useToasts } from '@geist-ui/react'
import { useMediaQuery } from '@material-ui/core'
import { Reply } from '@material-ui/icons'
import * as React from 'react'
import styled from 'styled-components'

import TabsContainer from '../tabs/TabsContainer'
// import TimeToggle from './TimeToggle'
import TrendingCollectors from './TrendingCollectors'
import TrendingCreators from './TrendingCreators'
import TrendingTraders from './TrendingTraders'
import TrendingVideos from './TrendingVideos'
import TrendingVideosHome from './TrendingVideosHome'

export enum LeaderboardTime {
  DAY = 'today',
  WEEK = 'this week',
  MONTH = ' this month',
  ALL = 'all time',
}

export enum LeaderboardPageType {
  HOME,
  TRENDING,
}

const Leaderboard = ({
  type,
  initialTab,
  initialTime,
}: {
  type: LeaderboardPageType
  initialTab?: number
  initialTime?: number
}): JSX.Element => {
  const [index, setIndex] = React.useState(initialTab || 0)
  const [time, setTime] = React.useState<LeaderboardTime>(LeaderboardTime.ALL)
  const isMobile = useMediaQuery('(max-width: 43em)')
  const { copy } = useClipboard()
  const [, setToast] = useToasts()

  React.useEffect(() => {
    console.log('set TIME')
    setTime(LeaderboardTime.ALL)
  }, [initialTime])

  const handleCopy = () => {
    const timeParam =
      time === LeaderboardTime.WEEK ? 'week' : time === LeaderboardTime.MONTH ? 'month' : 'all'
    const tabParam =
      index === 0 ? 'videos' : index === 1 ? 'creators' : index === 2 ? 'collectors' : 'traders'
    copy(`https://glass.xyz/trending?type=${tabParam}&time=${timeParam}`)
    setToast({ text: 'Copied this leaderboard to your clipboard!', type: 'success' })
  }

  return (
    <StyledSkeletonContainer isHome={type === LeaderboardPageType.HOME}>
      {type !== LeaderboardPageType.HOME && (
        <TitleDiv>
          <Title isHome={false}>{`TRENDING`}</Title>
          <ShareButton onClick={() => handleCopy()}>
            <Reply
              style={{
                transform: 'scaleX(-1)',
                width: isMobile ? 20 : 25,
                height: isMobile ? 20 : 25,
                // marginRight: `5px`,
              }}
            />
            {`Share`}
          </ShareButton>
        </TitleDiv>
      )}
      {type === LeaderboardPageType.HOME ? (
        <Selection>
          <Header>
            <Title isHome={type === LeaderboardPageType.HOME}>{`TRENDING`}</Title>
            {/* <TimeToggle setTime={setTime} isHome={type === LeaderboardPageType.HOME} /> */}
          </Header>
          <TrendingVideosHome
            time={time}
            currentIndex={0}
            index={0}
            updateHeight={() => {
              console.log('')
            }}
          />
        </Selection>
      ) : (
        <Selection>
          {/* <TimeToggle setTime={setTime} isHome={false} initialTime={initialTime} /> */}
          <TabsContainer
            columns={['Videos', 'Creators', 'Collectors', 'Traders']}
            initialTab={initialTab ?? 1}
            lastTab={4}
            tabCount={3}
            small={isMobile}
            setOuterIndex={setIndex}
          >
            {(index, updateHeight) => (
              <TrendingVideos
                time={time}
                currentIndex={index}
                index={0}
                updateHeight={updateHeight}
              />
            )}
            {(index, updateHeight) => (
              <TrendingCreators
                time={time}
                currentIndex={index}
                index={1}
                updateHeight={updateHeight}
              />
            )}
            {(index, updateHeight) => (
              <TrendingCollectors
                time={time}
                currentIndex={index}
                index={2}
                updateHeight={updateHeight}
              />
            )}
            {(index, updateHeight) => (
              <TrendingTraders
                time={time}
                currentIndex={index}
                index={3}
                updateHeight={updateHeight}
              />
            )}
          </TabsContainer>
        </Selection>
      )}
    </StyledSkeletonContainer>
  )
}

export default Leaderboard

const itemsContainerStyle = (isHome: boolean) =>
  isHome
    ? `
  display: flex;
  flex-wrap: wrap;
  position: relative;
  z-index: 0;
  margin-top: 20px;
  /* margin: auto; */
  // mobile
  // margin-top: 25px;
  width: calc(100% - 40px);
  margin-left: 12px;
  margin-right: 12px;

  // tablet
  @media (min-width: 43em) {
    margin: 0;
    width: 100%;
  }

  // small desktop
  @media (min-width: 62em) {
    margin: 0;
    width: 90%;
  }

  // large desktop
  @media (min-width: 82em) {
    max-width: 1800px;
  }
`
    : `
  display: flex;
  flex-wrap: wrap;
  position: relative;
  z-index: 0;
  margin-top: 20px;
  /* margin: auto; */
  // mobile
  // margin-top: 25px;
  width: calc(100% - 40px);
  margin-left: 12px;
  margin-right: 12px;

  // tablet
  @media (min-width: 43em) {
    margin-left: 25px;
    margin-right: 25px;
    width: calc(100% - 50px);
  }

  // small desktop
  @media (min-width: 62em) {
    margin: 0;
    width: 90%;
  }

  // large desktop
  @media (min-width: 82em) {
    max-width: 1800px;
  }
`

const StyledSkeletonContainer = styled.div<{ isHome?: boolean }>`
  ${(props) => itemsContainerStyle(props.isHome ?? false)};
`

const Title = styled.div<{ isHome?: boolean }>`
  font-size: 30px;
  font-weight: 600;
  white-space: pre-wrap;
  text-align: left;
  width: calc(100% - 40px);

  @media (min-width: 43em) {
    /* margin: ${(props) => (props.isHome ? `5px 20px 20px` : `0`)}; */
    font-size: 48px;
  }

  @media (min-width: 62em) {
    margin: ${(props) => (props.isHome ? `5px 20px 20px` : `5px 0 20px`)};
    font-size: 42px;
    text-align: left;
  }

  @media (min-width: 82em) {
    font-size: 54px;
  }
`

const Selection = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
`

const Header = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  @media (min-width: 43em) {
    margin: 20px;
  }

  @media (min-width: 62em) {
    margin: 0;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }
`

const TitleDiv = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`

const ShareButton = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
  background: white;
  color: black;
  border-radius: 10px;
  padding: 8px 16px;
  font-weight: 700;
  gap: 5px;

  @media (min-width: 43em) {
    margin-left: 15px;
  }
`
